import { html } from 'lit';
const Info =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M20.75 6a.75.75 0 0 1-.75.75h-9.353a2.751 2.751 0 0 1-5.293 0H4a.75.75 0 0 1 0-1.5h1.354a2.751 2.751 0 0 1 5.292 0H20a.75.75 0 0 1 .75.75m0 6a.75.75 0 0 1-.75.75h-1.354a2.751 2.751 0 0 1-5.292 0H4a.75.75 0 0 1 0-1.5h9.354a2.751 2.751 0 0 1 5.293 0H20a.75.75 0 0 1 .75.75m0 6a.75.75 0 0 1-.75.75h-9.353a2.751 2.751 0 0 1-5.293 0H4a.75.75 0 0 1 0-1.5h1.354a2.751 2.751 0 0 1 5.292 0H20a.75.75 0 0 1 .75.75m-3.5-6a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m-8-6a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m0 12a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0" clip-rule="evenodd"/>
  </svg>
`;
export default Info;
